export const SAMPLE_COLUMNS = {
  id: 'id',
  createdAt: 'createdAt',
  employee: 'employee',
} as const;

export type SampleColumnKey = keyof typeof SAMPLE_COLUMNS;

export const SAMPLE_COLUMN_KEYS = Object.keys(SAMPLE_COLUMNS) as SampleColumnKey[];

export const DEFAULT_SAMPLE_COLUMNS = Object.values(SAMPLE_COLUMNS);
